import { Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { MenuMobileComponent } from '../shared/components/redesign/menu-mobile/menu-mobile.component';
import { Contato } from '../shared/model/contato/contato.model';
import { ChatConversaComponent } from './chat-conversa/chat-conversa.component';
import { ListaContatosChatComponent } from './lista-contatos-chat/lista-contatos-chat.component';
import { TemplatesChatService } from '../shared/service/templates-chat.service';
import { AtendimentoTransferido } from './chat-conversa/models/atendimento-transferido.model';
import { ModoListaContatos } from './lista-contatos-chat/models/modo-lista-contatos.model';
import { ModalCadastroContatoComponent } from '../contato/modal-cadastro-contato/modal-cadastro-contato.component';
import { MethodsUtils } from '../shared/util/methods.utils';
import { ContatoCriado } from '../contato/modal-cadastro-contato/models/contato-criado.model';
import { EMPTY, filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-chat',
  standalone: true,
  imports: [ListaContatosChatComponent, ChatConversaComponent],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.css'
})
export class ChatComponent implements OnInit {
  @ViewChild(ListaContatosChatComponent) lista?: ListaContatosChatComponent;

  contatoSelecionado = signal<Contato | null>(null);

  private readonly templatesChat = inject(TemplatesChatService);
  private readonly dialog = inject(MatDialog);

  readonly modo: ModoListaContatos = inject(ActivatedRoute).snapshot.data['modoLista'] ?? 'CHAT';

  ngOnInit(): void {
    this.templatesChat.preCarregarPrimeiraPagina(true);
  }

  selecionarContato(contato: Contato): void {
    contato.numero = contato.numero || contato.contato;
    this.contatoSelecionado.set(contato);
  }

  voltarParaLista(): void {
    this.contatoSelecionado.set(null);
  }

  aoAlterarFavorito(evento: { contatoId: number; favorito: boolean }): void {
    this.lista?.aplicarFavorito(evento.contatoId, evento.favorito);
  }

  aoEncerrarAtendimento(contatoId: number): void {
    if (this.modo === 'CONTATOS') {
      this.lista?.recarregarContato(contatoId).subscribe();
      return;
    }
    this.contatoSelecionado.set(null);
    this.lista?.removerContato(contatoId);
  }

  abrirCadastroContato(): void {
    this.dialog.open(ModalCadastroContatoComponent, MethodsUtils.configPainelLateralChat(null))
      .afterClosed()
      .pipe(
        filter((criado?: ContatoCriado): criado is ContatoCriado => !!criado?.id),
        switchMap(criado => this.lista?.adicionarContatoCriado(criado) ?? EMPTY)
      )
      .subscribe(contato => this.selecionarContato(contato));
  }

  aoTransferirAtendimento(transferencia: AtendimentoTransferido): void {
    const selecionado = this.contatoSelecionado();
    const numero = selecionado?.id === transferencia.contatoId ? selecionado.contato : undefined;
    this.lista?.recarregarContato(transferencia.contatoId, numero).subscribe(atualizado => {
      const atual = this.contatoSelecionado();
      if (atualizado === undefined || atual?.id !== transferencia.contatoId) return;
      if (!atualizado) {
        this.contatoSelecionado.set(null);
        return;
      }
      MethodsUtils.copiarEstadoAtendimento(atual, atualizado);
    });
  }

  abrirMenuMobile(): void {
    this.dialog.open(MenuMobileComponent, {
      width: '85%',
      maxWidth: '320px',
      height: '100dvh',
      maxHeight: '100dvh',
      position: { top: '0', left: '0' },
      panelClass: 'slide-modal-esquerda'
    });
  }
}
